import { createFileRoute } from '@tanstack/react-router';


export const Route = createFileRoute('/app/garage/')({
  // ?add=1 opens the add-vehicle drawer (deep-link from empty states / docs).
  validateSearch: (search) => ({
    add: search.add ? 1 : undefined,
  }),
});
